import React, { FC, useState, useRef } from 'react';
import { Autocomplete, Typography, InputAdornment } from '@mui/material';
import {
  StyledAutoCompleteTextField,
  StyledAutoCompletePaper,
} from 'views/rebranded-module/GeoViewV2/components/FilterAutoComplete/FilterAutoComplete.styles';
import { RiArrowDownSLine } from 'react-icons/ri';

const FilterAutoComplete: FC<any> = (props) => {
  const { label, ...restOfProps } = props;
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const renderAutoCompleteOption = (optionProps, option) => (
    <li {...optionProps}>
      <Typography className="FAOptionText" component="p">
        {option.name}
      </Typography>
    </li>
  );

  const handleArrowClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!open) {
      setOpen(true);
      inputRef.current?.focus();
    } else {
      setOpen(false);
    }
  };

  return (
    <Autocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      popupIcon={null}
      PaperComponent={StyledAutoCompletePaper}
      getOptionLabel={(option: any) => option.name}
      fullWidth
      renderOption={renderAutoCompleteOption}
      renderInput={(params) => (
        <StyledAutoCompleteTextField
          {...params}
          inputRef={inputRef}
          fullWidth
          placeholder={label}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment
                position="start"
                onClick={handleArrowClick}
                className={open ? 'open' : ''}
              >
                <RiArrowDownSLine />
              </InputAdornment>
            ),
          }}
        />
      )}
      {...restOfProps}
    />
  );
};

export { FilterAutoComplete };
